import type { ReactElement } from 'react';
import type { InterviewState } from '@proctoring/shared';

const LABELS: Record<InterviewState, string> = {
  scheduled: 'Scheduled',
  lobby_open: 'Lobby open',
  in_progress: 'In progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

/**
 * Colour follows *actionability*, not severity: the two states an interviewer can act on
 * (lobby open, in progress) are the ones that stand out.
 */
const CLASSES: Record<InterviewState, string> = {
  scheduled: 'border-session-border bg-session-panel-raised text-session-muted',
  lobby_open: 'border-severity-warning/40 bg-severity-warning/10 text-severity-warning',
  in_progress: 'border-severity-info/40 bg-severity-info/10 text-severity-info',
  completed: 'border-session-border bg-session-panel-raised text-session-dim',
  cancelled: 'border-severity-critical/40 bg-severity-critical/10 text-severity-critical',
};

export interface StateBadgeProps {
  state: InterviewState;
  className?: string;
}

export function StateBadge({ state, className }: StateBadgeProps): ReactElement {
  return (
    <span
      data-state={state}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${CLASSES[state]} ${className ?? ''}`}
    >
      {LABELS[state]}
    </span>
  );
}

export { LABELS as INTERVIEW_STATE_LABELS };
